var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.multipleFlag
    ? _c(
        "el-select",
        {
          staticClass: "dg-tree-select",
          attrs: {
            id: "multipleSelect",
            "popper-class": "dg-tree-select__popover",
            multiple: "",
            disabled: _vm.disabled,
            size: _vm.size,
          },
          on: { change: _vm.selectChange },
          model: {
            value: _vm.selectArray,
            callback: function ($$v) {
              _vm.selectArray = $$v
            },
            expression: "selectArray",
          },
        },
        [
          _vm.showSelectInput
            ? _c("el-input", {
                staticClass: "selectInput",
                attrs: { placeholder: _vm.placeholder },
                model: {
                  value: _vm.filterText,
                  callback: function ($$v) {
                    _vm.filterText = $$v
                  },
                  expression: "filterText",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-option",
            {
              key: _vm.none,
              staticStyle: { height: "100px", padding: "0px 2px" },
              attrs: { id: "tree-option", label: _vm.none, value: _vm.none },
            },
            [
              _c("el-tree", {
                ref: "selectTree",
                staticClass: "filter-tree",
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  "overflow-y": "auto",
                },
                attrs: {
                  id: "dgTreeSelect",
                  data: _vm.options,
                  "render-content": _vm.renderNode,
                  "filter-node-method": _vm.filterNode,
                  "highlight-current": "",
                  "show-checkbox": "",
                  "default-checked-keys": _vm.defaultExpandedKey,
                  clearable: _vm.clearable,
                  "node-key": _vm.props.value,
                  props: _vm.props,
                },
                on: { "check-change": _vm.checkChage, clear: _vm.clearHandle },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "el-select",
        {
          attrs: {
            "popper-class": "dg-tree-select__popover",
            value: _vm.valueTitle,
            clearable: _vm.clearable,
            size: _vm.size,
          },
          on: { clear: _vm.clearHandle },
        },
        [
          _vm.showSelectInput
            ? _c("el-input", {
                staticClass: "selectInput",
                attrs: { placeholder: _vm.placeholder },
                model: {
                  value: _vm.filterText,
                  callback: function ($$v) {
                    _vm.filterText = $$v
                  },
                  expression: "filterText",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-option",
            {
              staticClass: "options",
              attrs: { value: _vm.valueTitle, label: _vm.valueTitle },
            },
            [
              _c("el-tree", {
                ref: "selectTree",
                attrs: {
                  id: "tree-option",
                  accordion: _vm.accordion,
                  data: _vm.options,
                  props: _vm.props,
                  "node-key": _vm.props.value,
                  "default-expanded-keys": _vm.defaultExpandedKey,
                  "filter-node-method": _vm.filterNode,
                  "render-content": _vm.renderNode,
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }